<template>
	<div>
		<div class="reports">
			<div class="container-fluid report-date form-inline">
				<div class="form-group">
					<select @change="updateTables" v-model="month" class="form-control">
						<option value="1">{{ 'January' | translate }}</option>
						<option value="2">{{ 'February' | translate }}</option>
						<option value="3">{{ 'March' | translate }}</option>
						<option value="4">{{ 'April' | translate }}</option>
						<option value="5">{{ 'May' | translate }}</option>
						<option value="6">{{ 'June' | translate }}</option>
						<option value="7">{{ 'July' | translate }}</option>
						<option value="8">{{ 'August' | translate }}</option>
						<option value="9">{{ 'September' | translate }}</option>
						<option value="10">{{ 'October' | translate }}</option>
						<option value="11">{{ 'November' | translate }}</option>
						<option value="12">{{ 'December' | translate }}</option>
					</select>
					<select @change="updateTables" v-model="year" class="ml-2 form-control">
						<option v-for="year in yearList" :key="year" :value="year">{{ year }}
						</option>
					</select>
				</div>
			</div>

			<div id="report-container">
				<div class="nav-wrap">
					<ul class="nav nav-tabs">
						<li class="nav-item">
							<button class="nav-link" :class="tab === 'report' ? 'active' : ''" @click="tab = 'report'">
								{{ 'Report' | translate }}
							</button>
						</li>
						<li class="nav-item">
							<button class="nav-link" :class="tab === 'invoices' ? 'active' : ''" @click="tab = 'invoices'">
								{{ 'Invoices' | translate }}
							</button>
						</li>
						<li class="nav-item">
							<button class="nav-link" :class="tab === 'history' ? 'active' : ''" @click="tab = 'history'">
								{{ 'reportsPage.history.title' | translate }}
							</button>
						</li>
						<li class="nav-item" v-if="false">
							<button class="nav-link" :class="tab === 'acts' ? 'active' : ''" @click="tab = 'acts'">
								{{ 'Acts' | translate }}
							</button>
						</li>
					</ul>
					<a class="nav-btn" @click="downloadReport">
						<img src="../../assets/download.png" width="20" height="20" alt="" />
						<span>
							{{ 'export' | translate }}
						</span>
					</a>
				</div>
				<div class="tab-content container-fluid clearfix">
					<h2 v-if="tab === 'report'" class="text-center history-header">
						{{ 'Report' | translate }} {{ month }}.{{ year }}-{{
						franchiseTable.id
					}}
					</h2>
					<div class="table-responsive">
						<table class="table table-bordered table-striped">
							<tr class="table-indigo-primary  font-weight-bold">
								<th>{{ 'Region' | translate }}</th>
								<th>{{ 'Full name franchise' | translate }}</th>
								<th>{{ 'Students active' | translate }}</th>
								<th>{{ 'Сost of education' | translate }}</th>
								<th>{{ 'Turnover franchise' | translate }}</th>
								<th>PR(%)</th>
								<th>{{ 'Proprietor' | translate }}(%)</th>
							</tr>
							<tr class=" font-weight-bold">
								<td>{{ franchiseTable.region }}</td>
								<td>{{ franchiseTable.full_name }}</td>
								<td>
									{{ franchiseTable.students.active }}
								</td>
								<td>
									{{
						franchiseTable.price_min === null
							? 0
							: franchiseTable.price_min
					}}
									<!-- /
									{{
										franchiseTable.price_min_en === null
										? 0
										: franchiseTable.price_min_en
									}} -->
								</td>
								<td>{{ franchiseTable.turnover | makeSpace }}</td>
								<td>
									{{ franchiseTable.pr_sum | makeSpace }}
									{{ slicePrice(franchiseTable.pr_deposit) }}
								</td>
								<td class="text-success">
									{{ franchiseTable.royalty_sum | makeSpace }}
									{{ slicePrice(franchiseTable.royalty) }}
								</td>
							</tr>
							<tr v-for="item in franchiseTable.table_rows" :key="item.price">
								<td />
								<td />
								<td>
									{{ item.students }}
								</td>
								<td>
									{{ (+item.price).toFixed(2) | makeSpace }}
								</td>
								<td>
									{{ (+item.turnover).toFixed(2) | makeSpace }}
								</td>
								<td>
									{{ (+item.pr).toFixed(2) }}
								</td>
								<td>
									{{ (+item.royalty).toFixed(2) }}
								</td>
							</tr>
						</table>
					</div>

					<div class="search-input-wrapper">
						<div class="search-input-logo">
							<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g id="Search">
									<circle id="Ellipse_739" cx="9.76639" cy="9.76688" r="8.98856" stroke="#C3CCD9" stroke-width="1.5"
										stroke-linecap="round" stroke-linejoin="round" />
									<path id="Line_181" d="M16.0181 16.4854L19.5421 20.0002" stroke="#C3CCD9" stroke-width="1.5"
										stroke-linecap="round" stroke-linejoin="round" />
								</g>
							</svg>
						</div>

						<input type="text" class="search-input" v-model="searchInputValue" />

						<button @click="resetFilters" class="reset-filters-button">{{ 'Reset filters' | translate }}</button>
					</div>


					<div v-if="tab === 'report'" id="report-report">
						<div class="table-responsive student-table">
							<table class="table table-striped">
								<tr>
									<th>#</th>
									<th class="filtered-th" :class="{ active: filters.selectedByName.length > 0 }">
										<div @click="openFilterHandler('byName')">{{ 'Full name student' | translate }}</div>

										<div>
											<div @click="sortField('full_name')" class="order-arrow"
												:class="{ active: params.field == 'full_name', reverse: params.sort != 'ASC' }">
												<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
													<path
														d="M0.788733 2C0.353128 2 0 2.35313 0 2.78873C0 3.22434 0.353128 3.57746 0.788732 3.57746H15.2113C15.6469 3.57746 16 3.22434 16 2.78873C16 2.35313 15.6469 2 15.2113 2H0.788733ZM2.25352 6.16901C2.25352 6.60462 2.60665 6.95775 3.04225 6.95775H12.9577C13.3934 6.95775 13.7465 6.60462 13.7465 6.16901C13.7465 5.73341 13.3934 5.38028 12.9577 5.38028H3.04225C2.60665 5.38028 2.25352 5.73341 2.25352 6.16901ZM4.50704 9.5493C4.50704 9.9849 4.86017 10.338 5.29577 10.338H10.7042C11.1398 10.338 11.493 9.9849 11.493 9.5493C11.493 9.11369 11.1398 8.76056 10.7042 8.76056H5.29577C4.86017 8.76056 4.50704 9.11369 4.50704 9.5493ZM6.76056 12.9296C6.76056 13.3652 7.11369 13.7183 7.5493 13.7183H8.4507C8.88631 13.7183 9.23944 13.3652 9.23944 12.9296C9.23944 12.494 8.88631 12.1408 8.4507 12.1408H7.5493C7.11369 12.1408 6.76056 12.494 6.76056 12.9296Z" />
												</svg>
											</div>

											<FilterByName :filterList="studentFilterNamesList" v-model="filters.selectedByName"
												:isOpen="filters.isModalOpen == 'byName'" @close="filters.isModalOpen = false" />
										</div>
									</th>

									<!-- <th>{{ 'Start of study' | translate }}</th> -->

									<th class="filtered-th-price"
										:class="{ active: filters.selectedByDate.months.length > 0 || filters.selectedByDate.years.length > 0 }">
										<div @click="openFilterHandler('byStudyStart')">{{ 'Start of study' | translate }}</div>

										<div>
											<!-- <div @click="sortField('group_name')" class="order-arrow"
												:class="{ active: params.field == 'group_name', reverse: params.sort != 'ASC' }">
												<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
													<path
														d="M0.788733 2C0.353128 2 0 2.35313 0 2.78873C0 3.22434 0.353128 3.57746 0.788732 3.57746H15.2113C15.6469 3.57746 16 3.22434 16 2.78873C16 2.35313 15.6469 2 15.2113 2H0.788733ZM2.25352 6.16901C2.25352 6.60462 2.60665 6.95775 3.04225 6.95775H12.9577C13.3934 6.95775 13.7465 6.60462 13.7465 6.16901C13.7465 5.73341 13.3934 5.38028 12.9577 5.38028H3.04225C2.60665 5.38028 2.25352 5.73341 2.25352 6.16901ZM4.50704 9.5493C4.50704 9.9849 4.86017 10.338 5.29577 10.338H10.7042C11.1398 10.338 11.493 9.9849 11.493 9.5493C11.493 9.11369 11.1398 8.76056 10.7042 8.76056H5.29577C4.86017 8.76056 4.50704 9.11369 4.50704 9.5493ZM6.76056 12.9296C6.76056 13.3652 7.11369 13.7183 7.5493 13.7183H8.4507C8.88631 13.7183 9.23944 13.3652 9.23944 12.9296C9.23944 12.494 8.88631 12.1408 8.4507 12.1408H7.5493C7.11369 12.1408 6.76056 12.494 6.76056 12.9296Z" />
												</svg>
											</div> -->

											<FilterByDate :isOpen="filters.isModalOpen == 'byStudyStart'" @close="filters.isModalOpen = false"
												v-model="filters.selectedByDate" />
										</div>
									</th>

									<th class="filtered-th" :class="{ active: filters.selectedByGroup.length > 0 }">
										<div @click="openFilterHandler('byGroup')">{{ 'Group' | translate }}</div>

										<div>
											<div @click="sortField('group_name')" class="order-arrow"
												:class="{ active: params.field == 'group_name', reverse: params.sort != 'ASC' }">
												<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
													<path
														d="M0.788733 2C0.353128 2 0 2.35313 0 2.78873C0 3.22434 0.353128 3.57746 0.788732 3.57746H15.2113C15.6469 3.57746 16 3.22434 16 2.78873C16 2.35313 15.6469 2 15.2113 2H0.788733ZM2.25352 6.16901C2.25352 6.60462 2.60665 6.95775 3.04225 6.95775H12.9577C13.3934 6.95775 13.7465 6.60462 13.7465 6.16901C13.7465 5.73341 13.3934 5.38028 12.9577 5.38028H3.04225C2.60665 5.38028 2.25352 5.73341 2.25352 6.16901ZM4.50704 9.5493C4.50704 9.9849 4.86017 10.338 5.29577 10.338H10.7042C11.1398 10.338 11.493 9.9849 11.493 9.5493C11.493 9.11369 11.1398 8.76056 10.7042 8.76056H5.29577C4.86017 8.76056 4.50704 9.11369 4.50704 9.5493ZM6.76056 12.9296C6.76056 13.3652 7.11369 13.7183 7.5493 13.7183H8.4507C8.88631 13.7183 9.23944 13.3652 9.23944 12.9296C9.23944 12.494 8.88631 12.1408 8.4507 12.1408H7.5493C7.11369 12.1408 6.76056 12.494 6.76056 12.9296Z" />
												</svg>
											</div>

											<FilterByName :filterList="studentFilterGroupsList" v-model="filters.selectedByGroup"
												:isOpen="filters.isModalOpen == 'byGroup'" @close="filters.isModalOpen = false" />
										</div>
									</th>

									<!-- <th>{{ 'Language of instruction' | translate }}</th> -->

									<th class="filtered-th-price" :class="{ active: filters.selectedByPrice.length > 0 }">
										<div @click="openFilterHandler('byPrice')">{{ 'Сost of education' | translate }}</div>

										<div>
											<!-- <div @click="sortField('price')">|||</div> -->

											<FilterByName :filterList="studentFilterPriceList" v-model="filters.selectedByPrice"
												:isOpen="filters.isModalOpen == 'byPrice'" @close="filters.isModalOpen = false" />
										</div>
									</th>

									<th>{{ 'Remuneration' | translate }}</th>

									<th class="filtered-th" :class="{ active: filters.selectedByTeacher.length > 0 }">
										<div @click="openFilterHandler('byTeacher')">
											{{ 'Teacher' | translate }}
										</div>

										<div>
											<div @click="sortField('teacher')" class="order-arrow"
												:class="{ active: params.field == 'teacher', reverse: params.sort != 'ASC' }">
												<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
													<path
														d="M0.788733 2C0.353128 2 0 2.35313 0 2.78873C0 3.22434 0.353128 3.57746 0.788732 3.57746H15.2113C15.6469 3.57746 16 3.22434 16 2.78873C16 2.35313 15.6469 2 15.2113 2H0.788733ZM2.25352 6.16901C2.25352 6.60462 2.60665 6.95775 3.04225 6.95775H12.9577C13.3934 6.95775 13.7465 6.60462 13.7465 6.16901C13.7465 5.73341 13.3934 5.38028 12.9577 5.38028H3.04225C2.60665 5.38028 2.25352 5.73341 2.25352 6.16901ZM4.50704 9.5493C4.50704 9.9849 4.86017 10.338 5.29577 10.338H10.7042C11.1398 10.338 11.493 9.9849 11.493 9.5493C11.493 9.11369 11.1398 8.76056 10.7042 8.76056H5.29577C4.86017 8.76056 4.50704 9.11369 4.50704 9.5493ZM6.76056 12.9296C6.76056 13.3652 7.11369 13.7183 7.5493 13.7183H8.4507C8.88631 13.7183 9.23944 13.3652 9.23944 12.9296C9.23944 12.494 8.88631 12.1408 8.4507 12.1408H7.5493C7.11369 12.1408 6.76056 12.494 6.76056 12.9296Z" />
												</svg>
											</div>

											<FilterByName :filterList="studentFilterTeachersList" v-model="filters.selectedByTeacher"
												:isOpen="filters.isModalOpen == 'byTeacher'" @close="filters.isModalOpen = false" />
										</div>
									</th>

									<th>{{ 'Lock date' | translate }}</th>

									<th class="filtered-th-price">
										<div @click="openFilterHandler('byLock')">{{ 'Lock' | translate }}</div>

										<div>
											<FilterByBlock v-model="filters.selectedByBlock" :isOpen="filters.isModalOpen == 'byLock'"
												@close="filters.isModalOpen = false" />
										</div>
									</th>
								</tr>
								<tr v-for="(student, index) in studentTable" :key="index"
									:class="{ 'text-danger': student.date_deactivated !== null }">
									<td>{{ index + 1 }}</td>
									<td>
										<router-link :to="{
						name: 'Dashboard Profile',
						params: { id: student.id },
					}">
											{{ student.full_name }}
										</router-link>
										<router-link :to="{
						name: 'Dashboard Student Main',
						query: { read_only: student.id },
					}">{{ 'To cabinet' | translate }}
										</router-link>
									</td>
									<td>{{ setStudyPeriod(student.study_period) }}</td>

									<td>{{ student.group_name }}</td>
									<!-- <td>{{ student.default_language }}</td> -->
									<td>
										<div class="price-block">
											<!-- <div :class="{ 'first-price': getPriceMod(student.study_period, student.price_first_month) }">
												{{ getCurrentPrice(student.study_period, student.price_first_month, student.price).price }}
											</div> -->

											<!-- <a v-if="getPriceMod(student.study_period, student.price_first_month) == 'mixed'">
												<span class="first-price">{{ slicePrice(student.price_first_month) }}</span>
												/
												{{ !student.price ? 0 : slicePrice(student.price) }}
											</a> -->
											<div @click.prevent="openPriceModal({
						id: student.id,
						price: student.price,
						price_first_month: student.price_first_month,
						index,
						name: student.full_name
					})">
												<a v-if="getPriceMod(student.study_period, student.price_first_month) == 'first'">
													<span class="first-price">{{ slicePrice(student.price_first_month) }}</span>
												</a>

												<a v-else>
													{{ !student.price ? 0 : slicePrice(student.price) }}
												</a>
											</div>

											<div class="comments" :class="{ empty: !student.comments }" @click.prevent="openCommentModal({
						id: student.id, comment: student.comments, index,
						name: student.full_name
					})">
												<div class="comments-logo">
													<svg width="16" height="16" viewBox="0 0 16 16" fill="none"
														xmlns="http://www.w3.org/2000/svg">
														<g id="Comment" clip-path="url(#clip0_1361_4)">
															<g id="Vector">
																<path
																	d="M8.94753 6.4006C8.54147 6.4006 8.22682 6.71524 8.22682 7.10372C8.22682 7.4922 8.54147 7.80685 8.94753 7.80685C9.31843 7.80685 9.63307 7.4922 9.63307 7.10372C9.63307 6.71524 9.31843 6.4006 8.94753 6.4006ZM4.02565 6.4006C3.6196 6.4006 3.30495 6.71524 3.30495 7.10372C3.30495 7.4922 3.6196 7.80685 4.02565 7.80685C4.39655 7.80685 4.7112 7.4922 4.7112 7.10372C4.7112 6.71524 4.39655 6.4006 4.02565 6.4006Z" />
																<path
																	d="M14.5896 5.06329C13.7763 3.94381 12.6037 3.1372 11.2673 2.77813V2.77989C10.9668 2.4459 10.6275 2.13829 10.2478 1.86407C7.37028 -0.227729 3.33082 0.410357 1.23023 3.2879C-0.462539 5.62579 -0.390469 8.77051 1.3357 11.0047L1.34977 13.3356C1.34977 13.3918 1.35855 13.4481 1.37613 13.5008C1.39824 13.5712 1.43402 13.6366 1.48143 13.6932C1.52883 13.7498 1.58693 13.7965 1.6524 13.8306C1.71787 13.8647 1.78943 13.8856 1.86297 13.8921C1.93652 13.8985 2.01061 13.8904 2.08102 13.8682L4.30641 13.1668C4.89527 13.376 5.50348 13.4955 6.10817 13.5289L6.09938 13.5359C7.66559 14.6768 9.71871 15.0195 11.6013 14.3973L13.8355 15.125C13.8918 15.1426 13.9498 15.1531 14.0095 15.1531C14.3207 15.1531 14.572 14.9018 14.572 14.5906V12.2352C16.1207 10.1328 16.1611 7.22715 14.5896 5.06329ZM4.5525 11.9188L4.34156 11.8309L2.60133 12.3758L2.58375 10.5477L2.44313 10.3895C0.956016 8.5754 0.857578 5.96153 2.24977 4.04376C3.9443 1.71993 7.19274 1.20665 9.50953 2.8836C11.8334 4.57286 12.3484 7.81602 10.6697 10.1258C9.26168 12.0576 6.74098 12.7713 4.5525 11.9188ZM13.4295 11.6199L13.2888 11.7957L13.3064 13.6238L11.5838 13.0438L11.3728 13.1316C10.3884 13.4973 9.33903 13.5272 8.36695 13.2547L8.36344 13.2529C9.69943 12.8432 10.8664 12.0111 11.6892 10.8816C13.0322 9.03067 13.2502 6.70508 12.4697 4.72227L12.4802 4.7293C12.8845 5.01934 13.2554 5.38145 13.5701 5.81915C14.8463 7.56993 14.7742 9.95352 13.4295 11.6199Z" />
																<path
																	d="M6.48659 6.4006C6.08053 6.4006 5.76589 6.71524 5.76589 7.10372C5.76589 7.4922 6.08053 7.80685 6.48659 7.80685C6.85749 7.80685 7.17214 7.4922 7.17214 7.10372C7.17214 6.71524 6.85749 6.4006 6.48659 6.4006Z" />
															</g>
														</g>
														<defs>
															<clipPath id="clip0_1361_4">
																<rect width="15.75" height="15.75" fill="white" transform="translate(0 0.125)" />
															</clipPath>
														</defs>
													</svg>
												</div>

												<!-- #2795E2 -->

												{{ student.comments || '...' }}
											</div>
										</div>

										<!-- /
										{{ student.price === null ? 0 : slicePrice(student.price) }}
										/
										{{
											student.price_first_month === null
											? 'null'
											: slicePrice(student.price_first_month)
										}} -->
									</td>
									<td>{{ student.student_royalty }}</td>
									<td>
										{{
						student.teacher
							? student.teacher
							: 'pageShop.item.status.DEPRECATED' | translate
					}}
									</td>

									<td>
										{{
							student.date_deactivated ? student.date_deactivated : '—'
						}}
									</td>

									<td class="lock-button">
										<svg v-if="!student.date_deactivated" width="24" height="24" viewBox="0 0 24 24" fill="none"
											xmlns="http://www.w3.org/2000/svg"
											@click.prevent="openLockModal({ id: student.id, price: student.price, index, name: student.full_name })">
											<g clip-path="url(#clip0_1187_670)">
												<path
													d="M19 8.424V7C19 5.14348 18.2625 3.36301 16.9497 2.05025C15.637 0.737498 13.8565 0 12 0C10.1435 0 8.36301 0.737498 7.05025 2.05025C5.7375 3.36301 5 5.14348 5 7V8.424C4.10936 8.81271 3.35129 9.45252 2.8185 10.2652C2.28571 11.0779 2.00128 12.0282 2 13V19C2.00159 20.3256 2.52888 21.5964 3.46622 22.5338C4.40356 23.4711 5.67441 23.9984 7 24H17C18.3256 23.9984 19.5964 23.4711 20.5338 22.5338C21.4711 21.5964 21.9984 20.3256 22 19V13C21.9987 12.0282 21.7143 11.0779 21.1815 10.2652C20.6487 9.45252 19.8906 8.81271 19 8.424ZM7 7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V8H7V7ZM20 19C20 19.7956 19.6839 20.5587 19.1213 21.1213C18.5587 21.6839 17.7956 22 17 22H7C6.20435 22 5.44129 21.6839 4.87868 21.1213C4.31607 20.5587 4 19.7956 4 19V13C4 12.2044 4.31607 11.4413 4.87868 10.8787C5.44129 10.3161 6.20435 10 7 10H17C17.7956 10 18.5587 10.3161 19.1213 10.8787C19.6839 11.4413 20 12.2044 20 13V19Z"
													fill="#2795E2" />
												<path
													d="M12 14C11.7348 14 11.4804 14.1054 11.2929 14.2929C11.1054 14.4804 11 14.7348 11 15V17C11 17.2652 11.1054 17.5196 11.2929 17.7071C11.4804 17.8946 11.7348 18 12 18C12.2652 18 12.5196 17.8946 12.7071 17.7071C12.8947 17.5196 13 17.2652 13 17V15C13 14.7348 12.8947 14.4804 12.7071 14.2929C12.5196 14.1054 12.2652 14 12 14Z"
													fill="#2795E2" />
											</g>
											<defs>
												<clipPath id="clip0_1187_670">
													<rect width="24" height="24" fill="white" />
												</clipPath>
											</defs>
										</svg>
									</td>
								</tr>
							</table>
						</div>
					</div>
					<div v-if="tab === 'invoices'">
						<div class="invoices-block">
							<div class="invoices-details">
								<p class="text-center">{{ 'Payment order' | translate }}</p>
								<div class="row">
									<div class="col-md-6">
										<div class="row align-items-center">
											<span class="col-4">{{ 'Payer' | translate }}</span>
											<span class="col-8">ФОП Мужановська Марина Мечiславiвна</span>
											<span class="col-4">{{ 'Code' | translate }}</span>
											<span class="col-8"><span class="code">2989409820</span></span>
											<span class="col-4">{{
						'Bank of the recipient' | translate
					}}</span>
											<span class="col-8">{{
							'PJSC CB "PRIVATBANK" in Kyiv' | translate
						}}</span>
										</div>
									</div>
									<div class="col-md-6">
										<div class="row align-items-center">
											<span class="col-4">{{ 'Account' | translate }}</span>
											<span class="col-8"><span class="code">26009056219902</span></span>
											<span class="col-4">{{ 'Bank code' | translate }}</span>
											<span class="col-8"><span class="code">380269</span></span>
										</div>
									</div>
								</div>
							</div>
							<div class="invoices-info">
								<h4>{{ 'Invoice for' | translate }} №{{ invoiceTable.id }}</h4>
								<div class="row">
									<p class="col-sm-6">
										{{ 'Supplier' | translate }}
										<span>Мужановська Марина Мечiславiвна</span>
									</p>
									<p class="col-sm-6">
										{{ 'Buyer' | translate }}
										<span>{{ franchiseTable.full_name }}</span>
									</p>
								</div>
							</div>
							<div class="table-responsive">
								<table class="table table-bordered table-striped">
									<tr>
										<th>#</th>
										<th>{{ 'Goods (works, services)' | translate }}</th>
										<th>{{ 'Quantity' | translate }}</th>
										<th>{{ 'Price' | translate }}</th>
										<th>{{ 'Amount' | translate }}</th>
										<th class="no-print">{{ 'Actions' | translate }}</th>
									</tr>
									<template v-for="inv in invoiceTable">
										<tr :key="index" v-for="(invoice, index) in inv.items">
											<td>{{ index + 1 }}</td>
											<td><input type="text" v-model="invoice.name" /></td>
											<td>
												<input @input="sumAll()" type="number" v-model="invoice.quantity" />
											</td>
											<td>
												<input @input="sumAll()" type="number" v-model="invoice.price" />
											</td>
											<td>
												{{ Number(invoice.price) * Number(invoice.quantity) }}
											</td>
											<td class="no-print">
												<a href="#" @click.prevent="removeServise(index)">{{
						'Delete' | translate
					}}</a>
											</td>
										</tr>
									</template>
								</table>

								<template v-if="myRole === 'super franchise'">
									<button @click="addService" class="btn btn-warning">
										{{ 'Add service' | translate }}
									</button>
									<button @click="saveInvoiceChanges" class="btn btn-success">
										{{ 'Save' | translate }}
									</button>
								</template>
							</div>
							<div class="invoices-sum row justify-content-end">
								<div class="col-sm-3" v-if="invoiceTable.length !== 0">
									<p>
										{{ 'Total' | translate }}
										<span>{{ invoiceTable[0].amount }}</span>
									</p>
									<p>
										{{ 'Including with' | translate }}
										<span>{{ invoiceTable[0].amount }}</span>
									</p>
								</div>
							</div>
						</div>
					</div>

					<div v-if="tab === 'history'">
						<div class="table-responsive history-table-wrapper">
							<table class="table table-bordered table-striped">
								<caption class="h3 text-center history-header">
									{{ 'reportsPage.history.title' | translate }}
								</caption>
								<thead>
									<tr class="history-table">
										<th class="filtered-th-price" :class="{ active: filters.selectedByHistoryAction.length > 0 }">
											<div @click="openFilterHandler('byHistoryAction')">
												{{ 'reportsPage.history.table.field_name' | translate }}
											</div>

											<div>
												<!-- <div @click="sortField('full_name')" class="order-arrow"
													:class="{ active: params.field == 'full_name', reverse: params.sort != 'ASC' }">
													<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
														<path
															d="M0.788733 2C0.353128 2 0 2.35313 0 2.78873C0 3.22434 0.353128 3.57746 0.788732 3.57746H15.2113C15.6469 3.57746 16 3.22434 16 2.78873C16 2.35313 15.6469 2 15.2113 2H0.788733ZM2.25352 6.16901C2.25352 6.60462 2.60665 6.95775 3.04225 6.95775H12.9577C13.3934 6.95775 13.7465 6.60462 13.7465 6.16901C13.7465 5.73341 13.3934 5.38028 12.9577 5.38028H3.04225C2.60665 5.38028 2.25352 5.73341 2.25352 6.16901ZM4.50704 9.5493C4.50704 9.9849 4.86017 10.338 5.29577 10.338H10.7042C11.1398 10.338 11.493 9.9849 11.493 9.5493C11.493 9.11369 11.1398 8.76056 10.7042 8.76056H5.29577C4.86017 8.76056 4.50704 9.11369 4.50704 9.5493ZM6.76056 12.9296C6.76056 13.3652 7.11369 13.7183 7.5493 13.7183H8.4507C8.88631 13.7183 9.23944 13.3652 9.23944 12.9296C9.23944 12.494 8.88631 12.1408 8.4507 12.1408H7.5493C7.11369 12.1408 6.76056 12.494 6.76056 12.9296Z" />
													</svg>
												</div> -->

												<FilterByName :filterList="historyFilterActionList" v-model="filters.selectedByHistoryAction"
													:isOpen="filters.isModalOpen == 'byHistoryAction'" @close="filters.isModalOpen = false"
													:disabledSearch="true" />
											</div>
										</th>

										<!-- <th>
											{{ 'reportsPage.history.table.old_value' | translate }}
										</th>
										<th>
											{{ 'reportsPage.history.table.new_value' | translate }} -->
										<!-- </th> -->

										<th class="filtered-th-price" :class="{ active: filters.selectedByHistoryUser.length > 0 }">
											<div @click="openFilterHandler('byHistoryUser')">{{ 'Student' | translate }}</div>

											<div>
												<!-- <div @click="sortField('full_name')" class="order-arrow"
													:class="{ active: params.field == 'full_name', reverse: params.sort != 'ASC' }">
													<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
														<path
															d="M0.788733 2C0.353128 2 0 2.35313 0 2.78873C0 3.22434 0.353128 3.57746 0.788732 3.57746H15.2113C15.6469 3.57746 16 3.22434 16 2.78873C16 2.35313 15.6469 2 15.2113 2H0.788733ZM2.25352 6.16901C2.25352 6.60462 2.60665 6.95775 3.04225 6.95775H12.9577C13.3934 6.95775 13.7465 6.60462 13.7465 6.16901C13.7465 5.73341 13.3934 5.38028 12.9577 5.38028H3.04225C2.60665 5.38028 2.25352 5.73341 2.25352 6.16901ZM4.50704 9.5493C4.50704 9.9849 4.86017 10.338 5.29577 10.338H10.7042C11.1398 10.338 11.493 9.9849 11.493 9.5493C11.493 9.11369 11.1398 8.76056 10.7042 8.76056H5.29577C4.86017 8.76056 4.50704 9.11369 4.50704 9.5493ZM6.76056 12.9296C6.76056 13.3652 7.11369 13.7183 7.5493 13.7183H8.4507C8.88631 13.7183 9.23944 13.3652 9.23944 12.9296C9.23944 12.494 8.88631 12.1408 8.4507 12.1408H7.5493C7.11369 12.1408 6.76056 12.494 6.76056 12.9296Z" />
													</svg>
												</div> -->

												<FilterByName :filterList="historyFilterUserList" v-model="filters.selectedByHistoryUser"
													:isOpen="filters.isModalOpen == 'byHistoryUser'" @close="filters.isModalOpen = false" />
											</div>
										</th>

										<th class="filtered-th-price" :class="{ active: filters.selectedByHistoryAuthor.length > 0 }">
											<div @click="openFilterHandler('byHistoryAuthor')">{{ 'Author' | translate }}</div>

											<div>
												<!-- <div @click="sortField('full_name')" class="order-arrow"
													:class="{ active: params.field == 'full_name', reverse: params.sort != 'ASC' }">
													<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
														<path
															d="M0.788733 2C0.353128 2 0 2.35313 0 2.78873C0 3.22434 0.353128 3.57746 0.788732 3.57746H15.2113C15.6469 3.57746 16 3.22434 16 2.78873C16 2.35313 15.6469 2 15.2113 2H0.788733ZM2.25352 6.16901C2.25352 6.60462 2.60665 6.95775 3.04225 6.95775H12.9577C13.3934 6.95775 13.7465 6.60462 13.7465 6.16901C13.7465 5.73341 13.3934 5.38028 12.9577 5.38028H3.04225C2.60665 5.38028 2.25352 5.73341 2.25352 6.16901ZM4.50704 9.5493C4.50704 9.9849 4.86017 10.338 5.29577 10.338H10.7042C11.1398 10.338 11.493 9.9849 11.493 9.5493C11.493 9.11369 11.1398 8.76056 10.7042 8.76056H5.29577C4.86017 8.76056 4.50704 9.11369 4.50704 9.5493ZM6.76056 12.9296C6.76056 13.3652 7.11369 13.7183 7.5493 13.7183H8.4507C8.88631 13.7183 9.23944 13.3652 9.23944 12.9296C9.23944 12.494 8.88631 12.1408 8.4507 12.1408H7.5493C7.11369 12.1408 6.76056 12.494 6.76056 12.9296Z" />
													</svg>
												</div> -->

												<FilterByName :filterList="historyFilterAuthorList" v-model="filters.selectedByHistoryAuthor"
													:isOpen="filters.isModalOpen == 'byHistoryAuthor'" @close="filters.isModalOpen = false" />
											</div>
										</th>

										<!-- <th>{{ 'reportsPage.history.table.user' | translate }}</th> -->

										<th class="filtered-th-price">
											<div @click="openFilterHandler('byHistoryPeriod')">
												{{ 'reportsPage.history.table.date' | translate }}
											</div>

											<div>
												<!-- <div @click="sortField('full_name')" class="order-arrow"
													:class="{ active: params.field == 'full_name', reverse: params.sort != 'ASC' }">
													<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
														<path
															d="M0.788733 2C0.353128 2 0 2.35313 0 2.78873C0 3.22434 0.353128 3.57746 0.788732 3.57746H15.2113C15.6469 3.57746 16 3.22434 16 2.78873C16 2.35313 15.6469 2 15.2113 2H0.788733ZM2.25352 6.16901C2.25352 6.60462 2.60665 6.95775 3.04225 6.95775H12.9577C13.3934 6.95775 13.7465 6.60462 13.7465 6.16901C13.7465 5.73341 13.3934 5.38028 12.9577 5.38028H3.04225C2.60665 5.38028 2.25352 5.73341 2.25352 6.16901ZM4.50704 9.5493C4.50704 9.9849 4.86017 10.338 5.29577 10.338H10.7042C11.1398 10.338 11.493 9.9849 11.493 9.5493C11.493 9.11369 11.1398 8.76056 10.7042 8.76056H5.29577C4.86017 8.76056 4.50704 9.11369 4.50704 9.5493ZM6.76056 12.9296C6.76056 13.3652 7.11369 13.7183 7.5493 13.7183H8.4507C8.88631 13.7183 9.23944 13.3652 9.23944 12.9296C9.23944 12.494 8.88631 12.1408 8.4507 12.1408H7.5493C7.11369 12.1408 6.76056 12.494 6.76056 12.9296Z" />
													</svg>
												</div> -->

												<FilterByPeriod :isOpen="filters.isModalOpen == 'byHistoryPeriod'"
													v-model="filters.selectedByHistoryPeriod" @close="filters.isModalOpen = false" />
											</div>
										</th>
									</tr>
								</thead>
								<tbody v-if="!historyTab.loading && !historyTab.error">
									<tr :key="change.modified" v-for="change in getHistoryData" class="history-table-body">

										<td>
											<!-- {{ getFieldName(change.field_name) }} -->

											<a class="operation-type price" v-if="change.field_name == 'price'">
												{{ 'Price' | translate }} {{ parseInt(change.old_value) }} -> {{ change.new_value }}
											</a>

											<a class="operation-type price" v-if="change.field_name == 'price_first_month'">
												{{ 'First month cost' | translate }} {{ parseInt(change.old_value) }} -> {{ change.new_value }}
											</a>

											<a class="operation-type price unlock"
												v-if="change.field_name == 'is_active' && change.new_value == 'True'">
												{{ "Unlocked" | translate }}
											</a>

											<a class="operation-type price lock"
												v-if="change.field_name == 'is_active' && change.new_value == 'False'">
												{{ 'Blocked' | translate }}
											</a>
										</td>

										<!-- <td>{{ change.old_value }}</td>
										<td>{{ change.new_value }}</td> -->

										<td>

											<template v-if="change.user_name">
												<router-link class="operation-type" :to="{
						name: 'Dashboard Profile',
						params: { id: change.user_id },
					}">
													{{ change.user_name }}
												</router-link>
											</template>
										</td>

										<td>

											<template v-if="change.author_name">
												<router-link class="operation-type" :to="{
						name: 'Dashboard Profile',
						params: { id: change.author_id },
					}">
													{{ change.author_name }}
												</router-link>
											</template>
										</td>

										<td class="operation-type date">{{ change.modified | formatDate }}</td>
									</tr>
								</tbody>
							</table>
							<div class="text-center">
								<div v-if="historyTab.loading" class="loader">
									<Loader />
								</div>
								<h4 v-else-if="historyTab.error" class="text-danger">
									Error occurred
								</h4>
								<p v-else-if="!historyTab.data || !historyTab.data.length" class="text-dark">
									{{ 'reportsPage.history.empty' | translate }}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<ModalDeleteStudent :show="isBlockModalOpen" @close="isBlockModalOpen = null" @deleteUser="deleteUser"
			@changePrice="changePrice" :choosedLockUser="choosedLockUser" />

		<ModalChangePrice :show="isPriceModalOpen" @close="isPriceModalOpen = null" @changePrice="changePrice"
			@changeFirstPrice="changePrice" :choosedPriceUser="choosedLockUser" />

		<ModalChangeComment :show="isCommentModalOpen" @close="isCommentModalOpen = null" @changeComment="changeComment"
			@changeFirstPrice="changeComment" :choosedCommentUser="choosedLockUser" />

	</div>
</template>

<script>
import Loader from '@/components/Loader'
import ModalDeleteStudent from './Modal/DeleteStudent'
import ModalChangePrice from './Modal/ChangePrice'
import ModalChangeComment from './Modal/ChangeComment'

import FilterByName from '../UI/FilterByName.vue'
import FilterByDate from '../UI/FilterByDate.vue'
import FilterByBlock from '../UI/FilterByBlock.vue'
import FilterByPeriod from '../UI/FilterByPeriod.vue'

const FileDownload = require('js-file-download')

export default {
	name: 'reports',
	components: { Loader, ModalDeleteStudent, ModalChangePrice, ModalChangeComment, FilterByName, FilterByDate, FilterByBlock, FilterByPeriod },
	data() {
		const yearList = []
		for (let year = 2017; year <= new Date().getFullYear(); year++) {
			yearList.push(year)
		}

		return {
			params: {
				field: null,
				sort: 'ASC',
			},
			historyTab: {
				loading: true,
				error: null,
				data: undefined,
			},
			yearList,
			tab: 'report',

			month: 1,
			year: 1,
			currentDate: new Date().getDate(),

			myRole: this.$store.state.myProfile.role,

			isBlockModalOpen: false,
			choosedLockUser: null,

			isPriceModalOpen: false,
			choosedPriceUser: null,

			isCommentModalOpen: null,

			searchQuery: '',
			searchInputValue: '',
			searchDebounceTimer: null,

			filters: {
				isModalOpen: false,

				selectedByName: [],

				selectedByGroup: [],

				selectedByTeacher: [],

				selectedByPrice: [],

				selectedByDate: {
					months: [],
					years: []
				},

				selectedByBlock: false,

				//History

				selectedByHistoryUser: [],

				selectedByHistoryAuthor: [],

				selectedByHistoryAction: [],

				selectedByHistoryPeriod: { from: null, to: null }
			}
		}
	},
	watch: {
		searchInputValue(value) {
			const timer = 1000

			if (this.searchDebounceTimer) {
				clearTimeout(this.searchDebounceTimer)
			}

			this.searchDebounceTimer = setTimeout(() => {
				this.searchQuery = value
			}, timer)
		}
	},
	computed: {
		franchiseTable() {
			return this.$store.state.reportFranchise
		},

		studentFilterNamesList() {
			return this.$store.state.reportStudent
				.map(i => ({
					name: i.full_name, email: i.email, id: i.id
				}))
				.filter((value, index, self) =>
					index === self.findIndex((t) => (
						t.name === value.name
					))
				)
		},

		studentFilterGroupsList() {
			return this.$store.state.reportStudent
				.map(i => ({
					name: i.group_name, id: i.id
				}))
				.filter((value, index, self) =>
					index === self.findIndex((t) => (
						t.name === value.name
					))
				)
		},

		studentFilterTeachersList() {
			return this.$store.state.reportStudent
				.map(i => ({
					name: i.teacher, id: i.id
				}))
				.filter((value, index, self) =>
					index === self.findIndex((t) => (
						t.name === value.name
					))
				)
		},

		studentFilterPriceList() {
			return this.$store.state.reportStudent
				.map(i => {
					const price = this.getPriceMod(i.study_period, i.price_first_month) == 'first' && i.price_first_month
						? i.price_first_month
						: i.price;

					return {
						name: price ? price : '0', id: i.id
					}
				})
				.filter((value, index, self) =>
					index === self.findIndex((t) => (
						t.name === value.name
					))
				)
		},

		historyFilterUserList() {
			return this.getHistoryData
				.map(i => ({
					name: i.user_name, id: i.user_id
				}))
				.filter((value, index, self) =>
					index === self.findIndex((t) => (
						t.name === value.name
					))
				)
		},

		historyFilterAuthorList() {
			return this.getHistoryData
				.map(i => ({
					name: i.author_name, id: i.author_id
				}))
				.filter((value, index, self) =>
					index === self.findIndex((t) => (
						t.name === value.name
					))
				)
		},

		historyFilterActionList() {
			return [
				{ name: 'Blocked', id: 1 },
				{ name: 'Unlocked', id: 2 },
				{ name: 'Price', id: 3 },
			]
		},

		studentTable() {
			let studentList = this.$store.state.reportStudent

			console.log('update')

			if (this.filters.selectedByName.length > 0) {
				studentList = studentList.filter(i => this.filters.selectedByName.includes(i.full_name))
			}

			if (this.filters.selectedByGroup.length > 0) {
				studentList = studentList
					.filter(i => this.filters.selectedByGroup.includes(i.group_name))

			}

			if (this.filters.selectedByTeacher.length > 0) {
				studentList = studentList.filter(i => this.filters.selectedByTeacher.includes(i.teacher))
			}

			if (this.filters.selectedByPrice.length > 0) {
				studentList = studentList.filter(i => {
					const price = this.getPriceMod(i.study_period, i.price_first_month) == 'first' && i.price_first_month
						? i.price_first_month
						: i.price;

					console.log(price)

					return this.filters.selectedByPrice.includes(price || '0')
				})
			}

			if (this.filters.selectedByDate.months.length > 0) {
				studentList = studentList.filter(i => this.filters.selectedByDate.months.includes(i.study_period.start.split('-')[1]))
			}

			if (this.filters.selectedByDate.years.length > 0) {
				studentList = studentList.filter(i =>
					this.filters.selectedByDate.years.includes(Number(i.study_period.start.split('-')[0]))
				)
			}

			if (this.filters.selectedByBlock) {
				studentList = studentList.filter(i => !!i.date_deactivated)
			}

			let report = this.searchQuery
				? studentList.filter(user => {
					const dataString = [user.full_name, user.teacher, this.setStudyPeriod(user.study_period), user.study_price, user.group_name].join(' ')

					return dataString.toLowerCase().includes(this.searchQuery.toLowerCase())
				})
				: studentList

			if (this.params.field) {
				report = report.sort((a, b) => {
					// if (this.params.sort === 'ASC') {
					// if (a[this.params.field] < b[this.params.field]) {
					// 	return -1
					// }
					// if (a[this.params.field > b[this.params.field]]) {
					// 	return 1
					// }
					// return 0

					if (a[this.params.field] && b[this.params.field]) {
						return a[this.params.field].localeCompare(b[this.params.field], undefined, {
							numeric: true,
							sensitivity: 'base'
						})
					} else {
						return -1
					}

					// } else {
					// if (a[this.params.field] > b[this.params.field]) {
					// 	return -1
					// }
					// if (a[this.params.field < b[this.params.field]]) {
					// 	return 1
					// }
					// return 0
					// }
				})
			}

			return this.params.sort === 'ASC' ? report : report.reverse()
		},

		getHistoryData() {
			let historyList = this.historyTab.data || []

			historyList = historyList.map(i => {
				return {
					user_name: `${i.user.last_name || ''} ${i.user.first_name || ''} ${i.user.email || ''}`,
					user_id: i.user.id,

					author_name: `${i.author.last_name || ''} ${i.author.first_name || ''} ${i.author.email || ''}`,
					author_id: i.author.id,

					modified: i.modified,

					field_name: i.field_name,
					old_value: i.old_value,
					new_value: i.new_value
				}
			})

			if (this.filters.selectedByHistoryUser.length > 0) {
				historyList = historyList.filter(i => this.filters.selectedByHistoryUser.includes(i.user_name))
			}

			if (this.filters.selectedByHistoryAuthor.length > 0) {
				historyList = historyList.filter(i => this.filters.selectedByHistoryAuthor.includes(i.author_name))
			}

			if (this.filters.selectedByHistoryAction.length > 0) {
				historyList = historyList.filter(i => {
					if (this.filters.selectedByHistoryAction.includes('Blocked') && i.field_name == 'is_active' && i.new_value == 'False') {
						return true
					}

					if (this.filters.selectedByHistoryAction.includes('Unlocked') && i.field_name == 'is_active' && i.new_value == 'True') {
						return true
					}

					if (this.filters.selectedByHistoryAction.includes('Price') && i.field_name == 'price') {
						return true
					}

					return false
				})
			}

			if (this.filters.selectedByHistoryPeriod.from || this.filters.selectedByHistoryPeriod.to) {
				// console.log(this.filters.selectedByHistoryPeriod[0] < this.filters.selectedByHistoryPeriod[1])
				if (this.filters.selectedByHistoryPeriod.from && this.filters.selectedByHistoryPeriod.to) {
					historyList = historyList.filter(i => {
						return new Date(i.modified) >= this.filters.selectedByHistoryPeriod.from && new Date(i.modified) <= this.filters.selectedByHistoryPeriod.to
					})
				}

				if (this.filters.selectedByHistoryPeriod.from && !this.filters.selectedByHistoryPeriod.to) {
					historyList = historyList.filter(i => {
						return new Date(i.modified) >= this.filters.selectedByHistoryPeriod.from
					})
				}

				if (!this.filters.selectedByHistoryPeriod.from && this.filters.selectedByHistoryPeriod.to) {
					historyList = historyList.filter(i => {
						return new Date(i.modified) <= this.filters.selectedByHistoryPeriod.to
					})
				}
			}

			if (this.searchQuery.length > 0) {
				return historyList.filter(change => {
					return `${change.user_name} ${change.author_name}`.toLowerCase().includes(this.searchQuery.toLowerCase())
				})
			}

			return historyList
		},

		invoiceTable() {
			return this.$store.state.reportInvoices
		},
	},
	filters: {
		makeSpace(val) {
			return val === null
				? 0
				: val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
		},
		formatDate(value) {
			if (!value) return '-'

			const format = v => v.toString().padStart(2, '0')

			const date = new Date(value)
			return `${format(date.getDate())}.${format(
				date.getMonth() + 1
			)}.${date.getFullYear()} / ${format(date.getHours())}:${format(
				date.getMinutes()
			)}:${format(date.getSeconds())}`
		},
	},

	methods: {
		resetFilters() {
			this.filters = {
				isModalOpen: false,

				selectedByName: [],

				selectedByGroup: [],

				selectedByTeacher: [],

				selectedByPrice: [],

				selectedByDate: {
					months: [],
					years: []
				},

				selectedByBlock: false,

				//History

				selectedByHistoryUser: [],

				selectedByHistoryAuthor: [],

				selectedByHistoryAction: [],

				selectedByHistoryPeriod: { from: null, to: null }
			}
		},
		openFilterHandler(type) {
			this.filters.isModalOpen == type ? this.filters.isModalOpen = false : this.filters.isModalOpen = type
		},

		openLockModal({ id, price, index, name }) {
			this.choosedLockUser = {
				// id, price: parseInt(price), oldPrice: parseInt(price), index, name,
				// isPriceChanged: false, isUserBlocked: false, isPriceLoading: false

				id,

				price: parseInt(price),
				oldPrice: parseInt(price),

				index,
				name,

				// firstPrice: parseInt(price_first_month || 0),
				// oldFirstPrice: parseInt(price_first_month || 0),

				isPriceChanged: false,
				isUserBlocked: false,
				isPriceLoading: false
			}
			this.isBlockModalOpen = true
		},

		openPriceModal({ id, price, index, name, price_first_month }) {
			this.choosedLockUser = {
				id,

				price: parseInt(price),
				oldPrice: parseInt(price),

				index,
				name,

				firstPrice: parseInt(price_first_month),
				oldFirstPrice: parseInt(price_first_month),

				isPriceChanged: false,
				isFirstPriceChanged: false,

				isUserBlocked: false,
				isPriceLoading: false
			}

			this.isPriceModalOpen = true
		},

		openCommentModal({ id, comment, name, index }) {
			this.choosedLockUser = {
				id, comment, name, index, isCommentLoading: false
			}

			this.isCommentModalOpen = true
		},

		changePrice() {
			this.choosedLockUser.isPriceLoading = true;

			let newPrice = {}

			if (this.choosedLockUser.price != this.choosedLockUser.oldPrice) {
				newPrice = { ...newPrice, price: Number(this.choosedLockUser.price) }
			}

			if (this.choosedLockUser.firstPrice != this.choosedLockUser.oldFirstPrice) {
				newPrice = { ...newPrice, price_first_month: Number(this.choosedLockUser.firstPrice) }
			}

			this.axios({
				method: 'patch',
				url: `users/user/${this.choosedLockUser.id}`,
				data: {
					...newPrice
				},
			})
				.then(response => {
					const newStudentTable = [...this.studentTable]

					newStudentTable[this.choosedLockUser.index] = {
						...newStudentTable[this.choosedLockUser.index],
						price: `${this.choosedLockUser.price}.00`,
						price_first_month: `${this.choosedLockUser.firstPrice}.00`
					}

					this.$toast(this.$t('Changes saved'), {
						className: ['btn-success', 'notif'],
						duration: 3000,
					})

					this.$store.commit('changeReportsStudent', newStudentTable)


					if (this.choosedLockUser.price != this.choosedLockUser.oldPrice) {
						this.choosedLockUser.oldPrice = this.choosedLockUser.price
						this.choosedLockUser.isPriceChanged = true
					}


					if (this.choosedLockUser.firstPrice != this.choosedLockUser.oldFirstPrice) {
						this.choosedLockUser.oldFirstPrice = this.choosedLockUser.firstPrice
						this.choosedLockUser.isFirstPriceChanged = true
					}

					this.choosedLockUser.isPriceLoading = false;
				})
				.catch(error => {
					console.error(error)

					this.choosedLockUser.isPriceLoading = false;
				})
		},

		changeComment() {
			this.choosedLockUser.isCommentLoading = true;

			this.axios({
				method: 'patch',
				url: `users/user/${this.choosedLockUser.id}`,
				data: {
					comments: this.choosedLockUser.comment
				},
			})
				.then(response => {
					const newStudentTable = [...this.studentTable]

					newStudentTable[this.choosedLockUser.index] = {
						...newStudentTable[this.choosedLockUser.index],
						comments: this.choosedLockUser.comment
					}

					this.$toast(this.$t('Changes saved'), {
						className: ['btn-success', 'notif'],
						duration: 3000,
					})

					this.$store.commit('changeReportsStudent', newStudentTable)

					this.choosedLockUser.isCommentLoading = false;
				})
				.catch(error => {
					console.error(error)

					this.choosedLockUser.isCommentLoading = false;
				})
		},

		deleteUser() {
			const newStudentTable = [...this.studentTable]

			newStudentTable[this.choosedLockUser.index] = {
				...newStudentTable[this.choosedLockUser.index],
				date_deactivated: 'Just now'
			}

			// console.log(this.studentTable[this.choosedLockUser.index])

			// this.$store.commit('changeReportsStudent', newStudentTable)

			let delUrl = `users/user/${this.choosedLockUser.id}`

			this.axios({
				method: 'delete',
				url: delUrl,
			}).then(response => {
				this.$store.commit('changeReportsStudent', newStudentTable)

				this.choosedLockUser.isUserBlocked = true
			})
		},

		getPriceMod(date, first_price) {
			const startMonthAndYear = `${Number(date.start.split('-')[1])} ${Number(date.start.split('-')[0])}`

			const currentMonthAndYear = `${Number(this.month)} ${Number(this.year)}`

			if (this.currentDate < 3) {
				const previousMonthAndYear = Number(this.month - 1) == 0
					? `12 ${Number(this.year - 1)}`
					: `${Number(this.month) - 1} ${Number(this.year)}`

				if (first_price && startMonthAndYear == previousMonthAndYear) {
					return 'first'
				}
			}

			if (first_price && startMonthAndYear == currentMonthAndYear) {
				return 'first'
			} else {
				return 'full'
			}
		},

		sortField(field) {
			// this.studentTable = this.studentTable.sort((a, b) => b[field] < a[field])
			this.params = { field, sort: this.params.sort === 'ASC' ? 'DESC' : 'ASC' }
		},

		downloadReport(e) {
			e && e.preventDefault()
			let userId = this.$store.state.myProfile.id
			!userId &&
				(userId = JSON.parse(localStorage.getItem('userProfile'))?.id ?? null)

			if (this.$route.params.id !== 'me') {
				userId = this.$route.params.id
			}
			const month =
				String(this.month).length === 1
					? '0' + String(this.month)
					: String(this.month)
			const url = `/billing/reports/monthly_report?user_id=${userId}&report_date=${month}-01-${this.year}`
			userId &&
				this.axios({
					url,
					method: 'GET',
					responseType: 'blob',
				}).then(async ({ data }) => {
					await FileDownload(data, 'report.xlsx')
				})
		},
		getFieldName(val) {
			switch (val) {
				case 'price':
					return this.$t('Price')
				// case 'price_en':
				// 	return `${this.$t('Price')} EN`
				case 'royalty':
					return this.$t('Royalty')
				case 'royalty_en':
					return `${this.$t('Royalty')} EN`
				case 'pr_deposit':
					return this.$t('PR contribution')
				case 'price_min':
					return this.$t('Сost of education')
				case 'price_min_en':
					return `${this.$t('Сost of education')} EN`
				default:
					return val
			}
		},
		getHistoryList() {
			this.historyTab = {
				loading: true,
				error: null,
				data: undefined,
			}

			const id =
				this.$route.params.id === 'me'
					? this.$store.state.myProfile.id
					: this.$route.params.id

			this.axios({
				url: `users/user/${id}/changes_history`,
			})
				.then(resp => {
					this.historyTab = {
						...this.historyTab,
						loading: false,
						data: resp.data,
					}
				})
				.catch(e => {
					this.historyTab = {
						...this.historyTab,
						loading: false,
						error: e,
					}
				})
		},
		sumAll() {
			this.invoiceTable[0].amount = 0
			this.invoiceTable[0].items.forEach(invoice => {
				this.invoiceTable[0].amount =
					Number(invoice.price) * Number(invoice.quantity) +
					Number(this.invoiceTable[0].amount)
			})
		},
		payForInvoice() {
			let reportInvoices = this.$store.state.reportInvoices
			reportInvoices[0].status = 'paid'
			this.axios({
				method: 'patch',
				url: `billing/invoices/${this.$store.state.reportInvoices[0].id}/make_paid`,
			}).then(resp => {
				this.$toast(this.$t('Changes saved'), {
					className: ['btn-success', 'notif'],
					duration: 3000,
				})
				this.$store.commit('changeReportsInvoices', reportInvoices)
			})
		},
		addService() {
			let reportInvoices = this.$store.state.reportInvoices
			let newItem = {
				name: '',
				quantity: 0,
				currency: '',
				price: 0,
				is_deletable: true,
				order: 0,
				status: 'unpaid',
				invoice: 0,
			}
			if (reportInvoices.length === 0) {
				this.$store.commit('changeReportsInvoices', [
					{
						id: 0,
						amount: '0',
						status: '',
						created: '',
						updated: null,
						user: 0,
						items: [newItem],
					},
				])
			} else {
				reportInvoices[0].items.push(newItem)
				this.$store.commit('changeReportsInvoices', reportInvoices)
			}
		},
		removeServise(index) {
			let reportInvoices = this.$store.state.reportInvoices
			reportInvoices[0].items.splice(index, 1)
			this.$store.commit('changeReportsInvoices', reportInvoices)
		},
		setStudyPeriod(date) {
			let start =
				date.start.slice(8, 10) +
				'.' +
				date.start.slice(5, 7) +
				'.' +
				date.start.slice(0, 4)
			return start
		},
		saveInvoiceChanges() {
			this.axios({
				method: 'patch',
				url: `billing/invoices/${this.$store.state.reportInvoices[0].id}`,
				data: this.invoiceTable,
			}).then(resp => {
				this.$toast(this.$t('Changes saved'), {
					className: ['btn-success', 'notif'],
					duration: 3000,
				})
			})
		},
		slicePrice(val) {
			return val !== null ? val.slice(0, -3) : ''
		},
		updateTables(getDate) {
			this.$store.commit('changeReportsFranchise', {
				id: 0,
				region: '',
				full_name: '',
				students: {
					total: 0,
					active: 0,
					inactive: 0,
				},
				price: 0,
				// price_en: 0,
				turnover: 0,
				pr_deposit: '0',
				pr_sum: 0,
				discount: '',
				royalty: '',
				royalty_sum: 200,
				contract_number: '',
				discount_sum: 0,
			})

			this.$store.commit('changeReportsStudent', [
				{
					full_name: '',
					bonus_days: 0,
					group_name: '',
					default_language: '',
					// price_en: '',
					price: '',
					study_period: {
						start: '',
						end: '',
					},
					days_count: 0,
					days_total: 0,
					study_price: 0,
					discount: 0,
					student_royalty: 0,
				},
			])

			this.$store.commit('changeReportsInvoices', [
				{
					id: 0,
					amount: '0',
					status: 'unpaid',
					created: '',
					updated: null,
					user: 0,
					items: [
						{
							id: 0,
							name: '',
							quantity: 0,
							currency: '',
							price: '0',
							is_deletable: true,
							order: 0,
							invoice: 0,
						},
					],
				},
			])

			const getTables = id => {
				let date = getDate ? '&month=' + this.month + '&year=' + this.year : ''
				this.axios({
					method: 'get',
					url: `billing/reports/${id}?role=franchise${date}`,
				}).then(resp => {
					this.$store.commit('changeReportsFranchise', resp.data)
				})
				this.axios({
					method: 'get',
					url: `billing/reports?role=student&franchise=${id}${date}`,
				}).then(resp => {
					this.$store.commit('changeReportsStudent', resp.data)
				})
				this.axios({
					method: 'get',
					url: `billing/invoices?user=${id}${date}`,
				}).then(resp => {
					this.$store.commit('changeReportsInvoices', resp.data)
				})
			}

			if (this.$route.params.id === 'me') {
				getTables(this.$store.state.myProfile.id)
			} else {
				getTables(this.$route.params.id)
			}
		},
	},
	created() {
		if (this.$route.query.tab === 'invoice') {
			this.tab = 'invoices'
		}
		let date = new Date()
		this.month = date.getMonth() + 1
		this.year = date.getFullYear()
		this.getHistoryList()
		this.updateTables()
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">
// th {
// 	font-family: Montserrat;
// 	font-size: 16px;
// 	font-style: normal;
// 	font-weight: 700;

// 	text-transform: none !important;
// }

.reset-filters-button {
	margin-left: 15px;

	padding: 5px 15px;
	border-radius: 12px;
	border-color: #FAB610;
	background: #FAB610 !important;
	color: #FFF !important;
	font-family: Montserrat;
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
}

.student-table {
	min-height: 400px;
}

.filtered-th {
	display: flex;

	position: relative;

	&.active {
		color: #2795E2 !important;
	}
}

.filtered-th-price {
	position: relative;

	&.active {
		color: #2795E2 !important;
	}
}


.order-arrow {
	opacity: 0.5;

	margin: 0 0 5px 10px;

	& svg path {
		fill: #78909c;
	}

	&.active {
		opacity: 1;

		& svg path {
			fill: #2795E2;
		}
	}

	&.reverse {
		transform: rotate(180deg);
	}
}

.history-header {
	font-family: Montserrat;
	font-size: 24px;
	font-style: normal;
	font-weight: 700;

	color: #150722;
}

.history-table {
	& th {
		font-family: Montserrat;
		font-size: 16px;
		font-style: normal;
		font-weight: 700;

		text-transform: none !important;
	}

	&-wrapper {
		min-height: 500px;
	}
}

.reports {
	& td {
		// font-family: Montserrat !important;
		font-size: 14px !important;
		font-style: normal;
	}

}

.search-input-wrapper {
	position: relative;

	width: 100%;

	.search-input-logo {
		position: absolute;

		top: 11px;
		left: 10px;
	}

	.search-input {
		width: 300px;
		padding: 10px 10px 10px 40px;
		align-items: center;

		border-radius: 8px;
		border: 1px solid #B7AFBF;
	}
}

.operation-type {
	font-family: Montserrat;
	font-size: 14px;
	font-style: normal;
	font-weight: 700;

	&.price {
		color: #150722;
	}

	&.unlock {
		color: #5DCF3C;
	}

	&.lock {
		color: #EB5757;
	}

	&.date {
		color: #7F919D;
	}
}

.lock-button svg {
	cursor: pointer;
}

.table td {
	vertical-align: middle;
}

.price-block {
	display: flex;
	flex-wrap: wrap;
	align-items: center;

	color: #2795E2;
	font-family: Montserrat;
	font-size: 15px;
	font-style: normal;
	font-weight: 700;

	& .first-price {
		color: #5DCF3C !important;
	}
}

.comments {
	position: relative;

	cursor: pointer;

	min-height: 37px;

	padding: 10px 10px 10px 30px;

	color: #999EB5;

	font-family: Montserrat;
	font-size: 12px;
	font-style: normal;
	font-weight: 500;

	line-height: normal;

	border-radius: 8px;
	border: 1px solid #B7AFBF;
	background: #FFF;

	width: 200px;

	margin-left: auto;

	& svg {
		fill: #2795E2
	}

	&.empty svg {
		fill: #999EB5
	}

	& .comments-logo {
		position: absolute;

		top: 9px;
		left: 7px;
	}
}

.nav-wrap {
	display: flex;
	align-items: flex-start;
	position: relative;
}

.nav-btn {
	margin: 20px 0;
	padding: 8px 16px;
	transform: translateY(2px);
	display: flex;
	align-items: center;
	background: #e69c50;
	color: #313131;
	right: 20px;
	top: 0px;
	position: absolute;
	border-top-left-radius: 0.25rem;
	border-top-right-radius: 0.25rem;
	/*flex-direction: column;*/
	justify-content: center;
}

.nav-btn span {
	color: #313131 !important;
	margin-left: 8px;
}

.nav-tabs {
	flex: 1;
	margin-bottom: 40px;
}

.table-indigo-primary th {
	background-color: #e69c50;
	color: #313131 !important;
}

.btn-secondary {
	margin: 10px;
}

/* REPORTS */

.report-date .status {
	color: #85bc63;
	margin-left: 20px;
	display: inline-block;
}

.report-date .status i {
	font-size: 22px;
	vertical-align: middle;
}

.reports p {
	font-size: 18px;
	color: #4a4da4;
}

.report-info {
	float: right;
}

#report-report .btn-group {
	display: inline-block;
}

h2 {
	color: #4a4da4;
	font-size: 36px;
	margin-top: 60px;
}

#report-container .nav {
	margin-top: 20px;
	padding: 0 15px;
	border-bottom: 1px solid #719cd4;
}

#report-container .nav-pills>li>a {
	border-bottom-right-radius: 0;
	border-bottom-left-radius: 0;
}

#report-container .nav-pills>li.active>a {
	background-color: #719cd4;
}

.invoices-block,
.invoices-details {
	border: 2px solid #dfdfdf;
	border-radius: 5px;
	padding: 15px;
	margin-bottom: 20px;
}

.invoices-details span {
	font-size: 18px;
	margin: 10px 0;
}

.invoices-details .code {
	border: 2px dashed #313131;
	display: inline-block;
	padding: 3px;
}

.invoices-block h4 {
	font-size: 26px;
	border-bottom: 2px solid #000;
}

.invoices-sum span,
.invoices-info span {
	float: right;
}

.table input {
	width: 100%;
	border: 0;
	outline: none;
}

caption {
	caption-side: top;
}

.loader svg {
	width: 100px;
	height: 100px;
}

/* END REPORTS */
</style>
